import * as React from 'react';
import { Layouts, NewbuildingLayoutsContext, ILayoutRoomCount } from '@cian/frontend-newbuilding-layouts-mobile-widget';
import { useApplicationContext } from '../../utils/applicationContext';
import { useSelector } from 'react-redux';
import {
  buildingHasLayoutsSelector,
  houseByIdSelector,
  housesMobileSelector,
  newbuildingIdSelector,
  roomsCountListSelector,
} from '../../selectors/newbuilding';
import { CallToActionContainer } from '../MobileCall';
import { HouseSelectContainer } from '../HouseSelectMobile';
import { MobileWidget } from '../../components/MobileWidget';
import { BuilderOffersNotAvailableMobile } from '../../components/BuilderOffersNotAvailableMobile';

/* istanbul ignore next */
export const LayoutsWidgetMobile = (): React.JSX.Element => {
  const { httpApi, logger } = useApplicationContext();

  const [houseId, setHouseId] = React.useState<number | undefined>();

  const newbuildingId = useSelector(newbuildingIdSelector);
  const hasLayouts = useSelector(buildingHasLayoutsSelector);
  const roomsCountList: ILayoutRoomCount[] = useSelector(roomsCountListSelector(houseId));
  const house = useSelector(houseByIdSelector(houseId));
  const houses = useSelector(housesMobileSelector);

  const isHouseLayoutsAvailable = houseId ? Boolean(house?.hasLayouts) : hasLayouts;

  const onHouseFilterReset = () => {
    setHouseId(undefined);
  };

  const contextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  if (!hasLayouts) {
    return <BuilderOffersNotAvailableMobile />;
  }

  return (
    <MobileWidget>
      <HouseSelectContainer houseId={houseId} onChange={setHouseId} houses={houses} />
      <NewbuildingLayoutsContext.Provider value={contextValue}>
        <Layouts
          favoriteButton={() => <div />}
          newbuildingId={newbuildingId}
          houseId={houseId}
          pageTypeJK="Seo"
          isHouseLayoutsAvailable={isHouseLayoutsAvailable}
          roomsCountList={roomsCountList}
          onHouseFilterReset={onHouseFilterReset}
          isLayoutModalDisabled={false}
          callButton={<CallToActionContainer openAction="Open_layout_modal_block" />}
          isQueryParamsEnabled={true}
        />
      </NewbuildingLayoutsContext.Provider>
    </MobileWidget>
  );
};
